<template>
<div class="page-shell legal-page">
  <HeadNav />

  <main>
    <header class="legal-hero">
      <div class="site-container narrow">
        <p class="eyebrow">Site policy</p>
        <h1>Disclaimer</h1>
        <p>Important information about the independent nature of gbwhata.io and the risks of third-party APK downloads.</p>
        <div class="article-meta">
          <span>Effective October 2026</span>
        </div>
      </div>
    </header>

    <div class="article-body">
      <div class="site-container narrow article-content">
        <h2>No Affiliation with WhatsApp or Meta</h2>
        <p>
          gbwhata.io is an independent information website. We are not affiliated with, endorsed by, sponsored by, or operated by WhatsApp, Meta, or any related company. WhatsApp and its logos are trademarks of their respective owners.
        </p>

        <h2>Unofficial Application</h2>
        <p>
          GB WhatsApp is an unofficial modified application. It is not an official WhatsApp release. WhatsApp does not support modified clients, and using one may result in temporary or permanent account restrictions.
        </p>

        <h2>Download and Use at Your Own Risk</h2>
        <p>
          Any APK, link, guide, or third-party service mentioned on this website is provided for general information. You are responsible for verifying the source, permissions, compatibility, and safety of any file before downloading or installing it.
        </p>

        <h2>No Security or Anti-Ban Guarantee</h2>
        <p>
          We do not guarantee that any modified application is safe, secure, uninterrupted, compatible with future WhatsApp changes, or protected from account restrictions. Claims that an APK is completely anti-ban should not be treated as guarantees.
        </p>

        <h2>Backups and Data Loss</h2>
        <p>
          Installing, updating, downgrading, or removing a messaging app can affect chats, media, and account access. Back up important data before making changes. We are not responsible for lost messages, lost media, account restrictions, device problems, or other damages resulting from installation or use.
        </p>

        <h2>External Links</h2>
        <p>
          External links are provided for convenience and may change without notice. We do not control and are not responsible for the content, policies, downloads, or security practices of third-party websites.
        </p>
      </div>
    </div>
  </main>
</div>
</template>

<script>
import HeadNav from '@/components/HeadNav.vue';

export default {
  name: 'Disclaimer',
  components: {
    HeadNav,
  },
};
</script>

<style lang="scss" scoped>
.legal-hero {
  padding: 70px 0 58px;
  background:
    linear-gradient(rgba(22, 163, 74, 0.05) 1px, transparent 1px),
    linear-gradient(90deg, rgba(22, 163, 74, 0.05) 1px, transparent 1px),
    linear-gradient(180deg, #eef7f1 0%, #f7fbf8 100%);
  background-size: 42px 42px, 42px 42px, auto;
  border-bottom: 1px solid var(--line);
}

.legal-hero h1 {
  color: var(--ink);
}

.legal-hero p:not(.eyebrow) {
  margin-bottom: 0;
  color: var(--ink-soft);
  font-size: 18px;
}
</style>
